import './TrialBanner.css'
import React from 'react'

import Link from './Link'
import { ICONTrialBanner } from '../icons'

export default ({ title, subtitle, buttonText, buttonUrl }) =>
    <section className='trial-banner'>
        <div className='trial-banner--content'>
            {title && <h3>{title}</h3>}
            {subtitle && <p>{subtitle}</p>}
        </div>
        {buttonText && buttonUrl && <Link className='button button-white' to={buttonUrl}>{buttonText}</Link>}
        <ICONTrialBanner />
    </section>


// WEBPACK FOOTER //
// ./src/components/TrialBanner.js